export default "__VITE_ASSET__3xXj8lJY__"